import styled from "styled-components";
import { InsuredDataContainer } from "../../common/insured-styles";

export const PymesInsuredContainer = styled(InsuredDataContainer)`
  .buttons {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    padding-right: 20px;

    &-item,
    .upload-button {
      width: 25%;
      min-width: 178px;
      margin-bottom: 10px;
    }
  }
`;
